import React from "react";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function PageHeading({ title, Subtitle }) {
  const navigate = useNavigate();
  return (
    <div className="mb-5 mt-2 flex items-start gap-2">
      {" "}
      <MdOutlineArrowBackIosNew
        onClick={() => navigate(-1)}
        className="h-5 w-5 mt-2 cursor-pointer hover:text-highlight"
      />
      <div>
        <h1 className="text-2xl font-medium text-black">{title}</h1>
        <p className="text-black">{Subtitle}</p>
      </div>
    </div>
  );
}
